export const MIN_BOARD_DIMENSION = 1;
export const MAX_BOARD_DIMENSION = 20;

export function normalizeBoardDimensionFloor(min: number): number {
  return Math.min(Math.max(MIN_BOARD_DIMENSION, min), MAX_BOARD_DIMENSION);
}

export function clampBoardDimension(value: number, floor: number): number {
  return Math.min(
    MAX_BOARD_DIMENSION,
    Math.max(Math.max(MIN_BOARD_DIMENSION, floor), value)
  );
}
